import { useEffect, useState } from 'react';
import PlantillaScreen from '../../helpers/PlantillaScreen';
import request from '../../../Helpers/API';
import Swal from 'sweetalert2';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from '../Helper/Icons';
import { apiMesAJsMonth, MONTHS_ES } from '../Helper/Mes';
import { useHistory } from "react-router-dom";
import { LoaderScreen } from '../../components/LoaderScreen';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ListadoJustificaciones from '../Helper/ListadoJustificaciones';
import { useSelector } from 'react-redux';
import ExtenderFechaJustificacionModal from './ExtenderFechaJustificacionModal';


const JustificacionesListadoScreen = () => {
    const today = new Date();
    const history = useHistory();

    const { roles } = useSelector((state) => state.sesion);
    const { idempleado } = useSelector((state) => state.usuario);



    const rolesPermitidos = ["REWR", "AAUD"];

    const [administrador, setAdministrador] = useState(false);
    const [folioFecha, setFolioFecha] = useState(null);
    const [diferencias, setDiferencias] = useState(null);
    const [justificadas, setJustificadas] = useState(null);
    const [fecha_finFecha, setFecha_FinFecha] = useState(null);
    const [openModalFecha, setOpenModalFecha] = useState(false);


    const [loading, setLoading] = useState(true);
    const [listado, setListado] = useState([]);
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const [calYear, setCalYear] = useState(today.getFullYear());
    const [calMonth, setCalMonth] = useState(today.getMonth()); // 0-11

    // Navegación
    const prevMonth = () => { if (calMonth === 0) { setCalMonth(11); setCalYear(y => y - 1); } else setCalMonth(m => m - 1); };
    const nextMonth = () => { if (calMonth === 11) { setCalMonth(0); setCalYear(y => y + 1); } else setCalMonth(m => m + 1); };

    const listadoOpciones = (ev) => [
        // Iniciar conteo solo si los 3 archivos están cargados
        { label: "Justificar", onClick: () => onJustificar(ev.folio) },

        ...(administrador ? [
            { label: "Extender fecha justificacón", onClick: () => onExtenderFecha(ev) },
        ] : []),

        ...(administrador || Number(ev.id_auditor_ppal) === Number(idempleado) ? [
            {
                label: "Reporte ajustes",
                subOptions: [
                    { label: "PDF", onClick: () => onAjustePDF(ev, "pdf") },
                ]
            },
        ] : []),

    ];

    // ── Eventos del mes visible para la vista Listado ────────────────────────
    const eventosDelMes = listado
        .filter(ev => apiMesAJsMonth(ev.mes) === calMonth && ev.anio === calYear)
        .sort((a, b) => new Date(b.fecha_creacion) - new Date(a.fecha_creacion)); // ← más reciente arriba

    useEffect(() => {
        onCargarDatos()

        if (roles.some(rol => rolesPermitidos.includes(rol.idrol))) {
            setAdministrador(true)
        }
    }, []);

    const onCargarDatos = () => {
        setLoading(true);
        request
            .get(`AuditoriaJustificaciones/ListadoFolios`)
            .then(result => setListado(result))
            .catch(err => Swal.fire("JUSTIFICACIONES", JSON.stringify(err), "error"))
            .finally(() => setLoading(false));
    }

    const onJustificar = (folio) => {
        history.push('/Auditoria/JustificarFolio', {
            folio: folio
        });
    }

    const onExtenderFecha = (ev) => {
        setFolioFecha(ev.folio);
        setFecha_FinFecha(ev.fecha_justificacion);
        setOpenModalFecha(true);
        setDiferencias(ev.diferencias)
        setJustificadas(ev.justificadas)
    };

    const onAjustePDF = (ev) => {
        setLoader({ ...loader, mostrar: true });

        request
            .get(`AuditoriaJustificaciones/ReporteAjuste?folio=${ev.folio}`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                const linkSource = `data:application/pdf;base64, ${result.documento}`;
                const downloadLink = document.createElement("a");
                const fileName = `${result.nombredocumento}.${result.extension}`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("Clientes", JSON.stringify(error), "error");
            });


    };

    const onRegresar = () => {

        history.push('/Auditoria/Main');
    };

    return (
        <PlantillaScreen
            titulo={"LISTADO DE FOLIOS JUSTIFICACIONES"}
            className="pa-root"
        >
            <LoaderScreen loader={loading} />

            <div className="programacion-auditoria-actions">
                <div
                    className="programacion-auditoria-actions-regresar"
                    onClick={() => onRegresar()}
                >
                    <ArrowBackIcon /> Regresar
                </div>
            </div>

            <div className="pa-calendar-panel">
                <div className="pa-cal-toolbar">
                    <div className="pa-cal-nav">
                        <button className="pa-cal-nav__btn" onClick={() => setCalYear(y => y - 1)} title="Año anterior"><ChevronsLeft /></button>
                        <button className="pa-cal-nav__btn" onClick={prevMonth} title="Mes anterior"><ChevronLeft /></button>
                        <div className="pa-cal-nav__label">
                            <span className="pa-cal-nav__month">{MONTHS_ES[calMonth]}</span>
                            <span className="pa-cal-nav__year">{calYear}</span>
                        </div>
                        <button className="pa-cal-nav__btn" onClick={nextMonth} title="Mes siguiente"><ChevronRight /></button>
                        <button className="pa-cal-nav__btn" onClick={() => setCalYear(y => y + 1)} title="Año siguiente"><ChevronsRight /></button>
                    </div>
                </div>


                <ListadoJustificaciones
                    data={eventosDelMes}
                    getOpciones={listadoOpciones}
                />
            </div>

            <ExtenderFechaJustificacionModal
                open={openModalFecha}
                onClose={() => setOpenModalFecha(false)}
                folio={folioFecha}
                fecha_fin={fecha_finFecha}
                onActualizar={onCargarDatos}
                diferencias={diferencias}
                justificadas={justificadas}
            />
        </PlantillaScreen>
    )
}

export default JustificacionesListadoScreen
